import React, { useEffect, useState } from 'react';
import './CalcAProofDtOutput.css';

// import {
//     createColumnHelper,
//     flexRender,
//     getCoreRowModel,
//     useReactTable,
// } from '@tanstack/react-table'
import { AProofElectrolyzer } from '../parts/CalcAProofData';


const defaultData: AProofElectrolyzer[] = [
];

// const columnHelper = createColumnHelper<AProofUnit>()

// const columns = [
//     // 日時
//     columnHelper.accessor('calculationDt', {
//         header: () => 'Day and time',
//         cell: info => info.getValue(),
//     }),
// ]

const rows = [
    {label: 'OUTPUT', unit: 'unit', key: 'output', data: 'operate', fraction: 0},
    {label: 'No.', unit: '-', key: 'no', data: 'no', fraction: 0},
    {label: 'Electrolyzer', unit: '-', key: 'electrolyzer', data: 'electrolyzer'},
    {label: 'Optimized Current', unit: 'kA', key: 'optimizedCurrent', data: 'optimizedCurrent', fraction: 2, clazz: "CalcAProofDtOutput_row_important"},
    {label: 'Estimated Value', unit: '-', key: 'estimatedValue', data: 'estimatedValue', titleOnly: true},
    {label: '   Elec. Voltage', unit: 'V', key: 'voltage', data: 'voltage', fraction: 1},
    {label: '   Temperature', unit: 'C', key: 'temp', data: 'temp', fraction: 1},
    {label: '   PC', unit: 'kWh/MT', key: 'pc', data: 'pc', fraction: 1},
    {label: '   NaOH Production', unit: 'MT/D', key: 'naohProduction', data: 'naohProduction', fraction: 1},
    {label: '   NaCl in 50% NaOH', unit: 'ppm', key: 'naclInNaoh50', data: 'naclInNaoh50', fraction: 0},
]

type Props = {
    units: AProofElectrolyzer[],
}

export const CalcAProofDtOutput: React.FC<Props> = ({units}) => {
    const [data, setData] = React.useState(() => [...defaultData])

    useEffect(() => {
        console.log('CalcAProofDtOutput: update. units.length=' + units.length);
        setData(units);
        console.log('CalcAProofDtOutput: update. data.length=' + data.length);
    }, [units]);
    // const table = useReactTable({
    //     data,
    //     columns,
    //     getCoreRowModel: getCoreRowModel(),
    // })

    return (
        <div className="CalcAProofDtOutput_content CalcAProofDtOutput_table">
            <table>
                <tbody>
                    {rows.map(row => (
                        <tr key={row.key} className={row.clazz}>
                            <th>
                                {row.label}
                            </th>
                            <td className="CalcAProofDtOuttput_cell_unit">
                                {row.unit}
                            </td>
                            {data.map((unit, index) => {
                                //console.log('CalcAProofDtOutput: index=' + index);
                                //console.log(unit);
                                if (row.titleOnly == true) {
                                    return (
                                        <td key={index}>
                                            -
                                        </td>
                                    );
                                } else {
                                    if (unit.output === undefined) {
                                        return (
                                            <td key={index}>
                                                
                                            </td>
                                        );
                                    } else {
                                        //console.log('key=' + row.key);
                                        //console.log(row.key in unit.output);
                                        if (row.data in unit.output) {
                                            let data : keyof typeof unit.output = row.data as keyof typeof unit.output;
                                            let cellData = unit.output[data];
                                            let fraction = row.fraction ? row.fraction : 0;
                                            if (row.label === "OUTPUT") {
                                                let clazz =
                                                ("operate" === cellData?.toString().toLowerCase()) ?
                                                        "CalcAProofDtOutput_operate_op" :
                                                        "CalcAProofDtOutput_operate_stop";
                                                //console.log('key=input clazz=' + clazz);
                                                return (
                                                    <td key={index}>
                                                        <span className={clazz}></span>
                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td key={index}>
                                                        {
                                                            typeof cellData == "number" ?
                                                                cellData.toLocaleString(
                                                                    undefined,
                                                                    {
                                                                        minimumFractionDigits: fraction,
                                                                        maximumFractionDigits: fraction
                                                                }) :
                                                                cellData
                                                        }
                                                    </td>
                                                );
                                            }
    
                                        } else {
                                            return (
                                                <td key={index}>
                                                    
                                                </td>
                                            );
                                        }
                                    }
                                }
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
